import {ChangeDetectionStrategy, Component, Inject, Injectable} from "@angular/core";
import {MuterendeOppgaveSpesifikasjon, OppgaveId, OppgaveModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {OppgaveDatatjeneste} from "felles-ng2/tjenester/datalager/OppgaveDatatjeneste";
import {MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {asynkArbeidPågårSignal, standardMinimumVarighetKonfig} from "felles-ng2/tjenester/AsynkArbeidPågårSignal";
import {OppgaveSkjemaKomponent} from "../../komponenter/oppgave-skjema/oppgave-skjema";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatToolbar} from "@angular/material/toolbar";
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {VisSpinnerDirektiv} from "web-ng2/delt/direktiver/button--visSpinner/button--visSpinner";
import {GjeldendeTidssone} from "felles-ng2/tjenester/i18n/GjeldendeTidssone";
import {OppgaveStatusSkjemaKomponent} from "../../komponenter/oppgave-status-skjema/oppgave-status-skjema";

const debug = initDebugger('OppgaveRedigerDialogKomponent');


/**
 * Dialog for å redigere oppgave
 */
@Component({
    selector: 'oppgave-rediger-dialog',
    templateUrl: 'oppgave-rediger-dialog.html',
    styleUrl: 'oppgave-rediger-dialog.scss',
    host: {'data-testid': 'oppgave-dialog-skjema'},
    imports: [
        MatButton,
        MatDialogActions,
        MatDialogContent,
        MatIcon,
        MatIconButton,
        MatToolbar,
        OppgaveSkjemaKomponent,
        ReactiveFormsModule,
        TranslateModule,
        VisSpinnerDirektiv,
        OppgaveStatusSkjemaKomponent
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OppgaveRedigerDialogKomponent {
    static vis(dialog: MatDialog, oppgave: OppgaveModell): MatDialogRef<OppgaveRedigerDialogKomponent, OppgaveRedigerDialogRespons> {
        return dialog.open(OppgaveRedigerDialogKomponent, {
            data: {oppgave} as DialogParametre,
            disableClose: true,
            ariaLabelledBy: 'oppgave-rediger-dialog-tittel',
            minWidth: 500
        });
    }

    oppgave: OppgaveModell; //kommer fra DialogParametre

    skjema = new FormGroup({
        oppgave: OppgaveSkjemaKomponent.opprettSkjema(),
        status: OppgaveStatusSkjemaKomponent.opprettSkjema()
    });

    lagrer = asynkArbeidPågårSignal(standardMinimumVarighetKonfig());

    constructor(@Inject(MAT_DIALOG_DATA) parametre: DialogParametre,
                private dialogRef: MatDialogRef<OppgaveRedigerDialogKomponent, OppgaveRedigerDialogRespons>,
                private avhengigheter: OppgaveRedigerDialogKomponentAvhengigheter,
                private gjeldendeTidssone: GjeldendeTidssone) {
        this.oppgave = parametre.oppgave;

        OppgaveSkjemaKomponent.populerSkjema(this.skjema.controls.oppgave, this.oppgave);
        OppgaveStatusSkjemaKomponent.populerSkjema(this.skjema.controls.status, this.oppgave, this.gjeldendeTidssone.brukersTidssone());
    }

    async lagre() {
        await this.lagrer.utfør(() => this.avhengigheter.oppdater(this.oppgave.id, this.somSpesifikasjon()));
        this.dialogRef.close(true);
    }

    avbryt() {
        this.dialogRef.close(false);
    }

    // private hjelpemetoder

    private somSpesifikasjon(): MuterendeOppgaveSpesifikasjon {
        return {
            ...OppgaveSkjemaKomponent.somSpesifikasjon(this.skjema.controls.oppgave, this.gjeldendeTidssone.brukersTidssone()),
            ...OppgaveStatusSkjemaKomponent.somSpesifikasjon(this.skjema.controls.status, this.gjeldendeTidssone.brukersTidssone())
        }
    }
}

export type OppgaveRedigerDialogRespons = boolean;

export type DialogParametre = {
    oppgave: OppgaveModell;
};

@Injectable()
export class OppgaveRedigerDialogKomponentAvhengigheter {

    constructor(private oppgaveDatatjeneste: OppgaveDatatjeneste) {
    }

    async oppdater(id: OppgaveId, spesifikasjon: MuterendeOppgaveSpesifikasjon): Promise<void> {
        await this.oppgaveDatatjeneste.oppdater(id, spesifikasjon);
    }
}
